export default __webpack_public_path__ + "static/media/4.4907cc85.svg";